import { render, staticRenderFns } from "./NjzlMaskImg.vue?vue&type=template&id=bc867022&scoped=true&"
import script from "./NjzlMaskImg.vue?vue&type=script&lang=js&"
export * from "./NjzlMaskImg.vue?vue&type=script&lang=js&"
import style0 from "./NjzlMaskImg.vue?vue&type=style&index=0&id=bc867022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc867022",
  null
  
)

export default component.exports